import { isArray, isEqual, isNil, isObject, isString } from "lodash"

function checkType(target: unknown, type: string) {
  return Object.prototype.toString.call(target).includes(type)
}

function isDate(target: unknown) {
  return checkType(target, "Date") && !isNaN(target as number)
}

function isEmpty(target: unknown) {
  if (isString(target)) {
    return target === ""
  }

  if (isArray(target)) {
    return target && (target as Array<unknown>).length === 0
  }

  if (isObject(target)) {
    return target && Object.keys(target).length === 0
  }

  return isNil(target)
}

function isEquals(target: unknown, compare: unknown) {
  // lodash isEqual 로는 배열의 순서 변경까지 감지 불가능
  if (isArray(target) && isArray(compare)) {
    if (target.length !== compare.length) {
      return false
    }

    return target.sort().some((item, index) => isEqual(item, compare.sort()[index]))
  }

  // lodash 로 중첩된 구조의 객체 비교 가능
  return target && compare && isEqual(target, compare)
}

function hasKey(target: unknown, key: string) {
  return Object.prototype.hasOwnProperty.call(target, key)
}

export { isEmpty, isEquals, isDate, hasKey }
